import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6af89f10"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card card-info" }
const _hoisted_2 = { class: "card-header d-flex align-items-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-info-circle mr-2 text-primary" }, null, -1))
const _hoisted_4 = {
  class: "d-flex flex-column",
  style: {"width":"200px"}
}
const _hoisted_5 = { class: "d-flex flex-column" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-weight-bold" }, "Manufacturer ", -1))
const _hoisted_7 = { class: "d-flex flex-column" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-weight-bold" }, "Model ", -1))
const _hoisted_9 = { class: "d-flex flex-column" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-weight-bold" }, "Date Manufacture ", -1))
const _hoisted_11 = { class: "d-flex flex-column" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-weight-bold" }, "Serial Number ", -1))
const _hoisted_13 = { class: "font-weight-bold" }
const _hoisted_14 = { class: "font-weight-bold" }
const _hoisted_15 = {
  key: 0,
  style: {"float":"right"}
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-angle-right icon-redirect" }, null, -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = {
  key: 1,
  style: {"float":"right"}
}
const _hoisted_19 = {
  key: 0,
  class: "row",
  style: {"height":"50px"}
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-left" }, null, -1))
const _hoisted_21 = {
  key: 1,
  class: "row pl-3 pt-2"
}
const _hoisted_22 = { class: "form-group col-lg-4" }
const _hoisted_23 = { class: "form-group col-lg-4" }
const _hoisted_24 = { class: "col-lg-4" }
const _hoisted_25 = {
  key: 2,
  class: "row",
  style: {"aspect-ratio":"10/4","min-height":"200px"}
}
const _hoisted_26 = ["hidden"]
const _hoisted_27 = {
  key: 3,
  class: "card-body livereading-card mt-4 p-3"
}
const _hoisted_28 = { class: "d-flex flex-wrap justify-content-around align-items-center" }
const _hoisted_29 = { class: "alarm-icon-container" }
const _hoisted_30 = ["title"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-triangle" }, null, -1))
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = ["title"]
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-circle" }, null, -1))
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = ["title"]
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check-circle" }, null, -1))
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = ["title"]
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times-circle" }, null, -1))
const _hoisted_41 = [
  _hoisted_40
]
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_43 = {
  key: 4,
  class: "row mr-1"
}
const _hoisted_44 = { class: "col-md-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_popover = _resolveComponent("n-popover")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_date_picker = _resolveComponent("n-date-picker")!
  const _component_ChartJs = _resolveComponent("ChartJs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.type == 'basic')
        ? (_openBlock(), _createBlock(_component_n_popover, {
            key: 0,
            trigger: "click",
            "show-arrow": false,
            class: "mr-2",
            placement: "down"
          }, {
            trigger: _withCtx(() => [
              _hoisted_3
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _createElementVNode("span", null, _toDisplayString(_ctx.equipment.manufacturer), 1)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("span", null, _toDisplayString(_ctx.equipment.model), 1)
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("span", null, _toDisplayString(_ctx.equipment.date_manufactured), 1)
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("span", null, _toDisplayString(_ctx.equipment.serial_number), 1)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.equipment.additional, (value, key) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: key,
                    class: "d-flex flex-column"
                  }, [
                    _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.snakeToCapital(key)), 1),
                    _createElementVNode("span", null, _toDisplayString(value), 1)
                  ]))
                }), 128)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.equipment.custom_field?.value ?? [], (customField) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "d-flex flex-column",
                    key: customField.id
                  }, [
                    _createElementVNode("span", _hoisted_14, _toDisplayString(customField.label), 1),
                    _createElementVNode("span", null, _toDisplayString(customField.value), 1)
                  ]))
                }), 128))
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "w-100",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openPage()))
      }, [
        _createElementVNode("span", null, _toDisplayString(_ctx.equipment.name), 1),
        (_ctx.type == 'basic')
          ? (_openBlock(), _createElementBlock("span", _hoisted_15, _hoisted_17))
          : _createCommentVNode("", true),
        (_ctx.type == 'advance')
          ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
              _createVNode(_component_n_button, {
                class: "flex-fill",
                type: "primary",
                dashed: "",
                size: "small",
                onClick: _ctx.onSearchToggle
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Search ")
                ]),
                _: 1
              }, 8, ["onClick"])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", null, [
      (_ctx.isShowOneMin)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _createElementVNode("span", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.backTo30min())),
              style: {"cursor":"pointer"},
              class: "ml-5 mt-3"
            }, [
              _hoisted_20,
              _createTextVNode(" Back")
            ])
          ]))
        : _createCommentVNode("", true),
      (!_ctx.isShowOneMin && _ctx.type == 'advance' && _ctx.searchToggle)
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createVNode(_component_n_date_picker, {
                id: "search-report-start",
                value: _ctx.search.startDatetime,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.search.startDatetime) = $event)),
                type: "datetime",
                format: "yyyy-MM-dd HH:mm",
                size: "medium",
                clearable: "",
                placeholder: "Start Date and Time"
              }, null, 8, ["value"])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createVNode(_component_n_date_picker, {
                id: "search-report-end",
                value: _ctx.search.endDatetime,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.search.endDatetime) = $event)),
                type: "datetime",
                format: "yyyy-MM-dd HH:mm",
                size: "medium",
                clearable: "",
                disabled: !_ctx.search.startDatetime,
                placeholder: "End Date and Time"
              }, null, 8, ["value", "disabled"])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createVNode(_component_n_button, {
                class: "mr-3",
                type: "primary",
                size: "medium",
                onClick: _ctx.searching,
                disabled: !(_ctx.search.startDatetime && _ctx.search.endDatetime)
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" SHOW RESULTS ")
                ]),
                _: 1
              }, 8, ["onClick", "disabled"]),
              _createVNode(_component_n_button, {
                strong: "",
                secondary: "",
                type: "primary",
                onClick: _ctx.reset,
                size: "medium"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" RESET ")
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.type == 'basic')
        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
            _createElementVNode("div", {
              class: "col position-relative",
              hidden: _ctx.isShowOneMin
            }, [
              _createVNode(_component_ChartJs, {
                options: _ctx.option,
                onChartjsOnlick: _ctx.min30Onclick,
                style: {"height":"50px"}
              }, null, 8, ["options", "onChartjsOnlick"])
            ], 8, _hoisted_26)
          ]))
        : _createCommentVNode("", true),
      (_ctx.type == 'basic')
        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.equipment.sensors, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "mb-1 text-center",
                  key: index
                }, [
                  _createElementVNode("b", null, [
                    _createElementVNode("span", {
                      class: "dot",
                      style: _normalizeStyle('background: ' + item.color)
                    }, null, 4),
                    _createTextVNode(" " + _toDisplayString(item.value) + " ", 1),
                    _createElementVNode("span", _hoisted_29, [
                      (_ctx.status(item.last_reading) && item.alarm_type == 77)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: "alarm-icon text-warning",
                            title: item.message
                          }, _hoisted_32, 8, _hoisted_30))
                        : (_ctx.status(item.last_reading) && item.alarm_type == 78)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 1,
                              class: "alarm-icon text-danger",
                              title: item.message
                            }, _hoisted_35, 8, _hoisted_33))
                          : (_ctx.status(item.last_reading))
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 2,
                                class: "alarm-icon text-success",
                                title: item.message
                              }, _hoisted_38, 8, _hoisted_36))
                            : (!_ctx.status(item.last_reading))
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 3,
                                  class: "alarm-icon text-black-50",
                                  title: item.message
                                }, _hoisted_41, 8, _hoisted_39))
                              : _createCommentVNode("", true)
                    ])
                  ]),
                  _hoisted_42,
                  _createElementVNode("small", null, _toDisplayString(item.name) + " (" + _toDisplayString(item.unit) + ")", 1)
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.type == 'advance')
        ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
            _createElementVNode("div", _hoisted_44, [
              _createVNode(_component_ChartJs, {
                hidden: _ctx.isShowOneMin,
                options: _ctx.option,
                onChartjsOnlick: _ctx.min30Onclick,
                style: {"height":"150px"}
              }, null, 8, ["hidden", "options", "onChartjsOnlick"]),
              _createVNode(_component_ChartJs, {
                hidden: !_ctx.isShowOneMin,
                options: _ctx.oneMinOption,
                style: {"height":"100px"}
              }, null, 8, ["hidden", "options"])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}